import EntryPoint from 'LazyEntryPoint'
import SplashSpinner from 'components/SplashSpinner/SplashSpinner'
import { startTransition, Suspense, useEffect, useState } from 'react'
import { mergeMeta } from 'utils/remixUtils'
import { type MetaFunction } from 'react-router'
import { PHOTO_BOOK_URL } from 'config/config'
import {
  PHOTO_BOOKS_DESCRIPTION,
  PHOTO_BOOKS_PREVIEW_IMAGE,
  PHOTO_BOOKS_TITLE,
  getTitleMetaTags,
  getDescriptionMetaTags,
  getImageMetaTags,
} from 'app/utils/meta'

export const meta: MetaFunction = mergeMeta(({ location }) => {
  if (location.pathname.startsWith(PHOTO_BOOK_URL)) {
    return [
      ...getTitleMetaTags(PHOTO_BOOKS_TITLE),
      ...getDescriptionMetaTags(PHOTO_BOOKS_DESCRIPTION),
      ...getImageMetaTags(PHOTO_BOOKS_PREVIEW_IMAGE),
    ]
  }

  return []
})

export default function IndexRoute() {
  const [mounted, setMounted] = useState(false)

  useEffect(() => {
    startTransition(() => {
      setMounted(true)
    })
  }, [])

  return (
    <Suspense fallback={<SplashSpinner />}>
      {mounted ? <EntryPoint /> : <SplashSpinner />}
    </Suspense>
  )
}
